import React, { useCallback, useEffect, useRef, useState } from "react";
import Wing from "../../assets/images/wing.png";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { useLanguage } from "../../context/LanguageContext";
import { getLocalizedFieldValue } from "../../utils/language";
import bannerBg from '../../assets/images/lg-bg.jpg'													

function Banner() {
  const wingRef = useRef(null);
  const sectionRef = useRef(null);
  const [startPoint, setStartPoint] = useState(0);
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(false);
  const { language } = useLanguage();

  const normalizeBannerData = (data) => {
    if (!data) return [];
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.banners)) return data.banners;
    if (Array.isArray(data)) return data;
    return [];
  };

  const fetchBanner = useCallback(async () => {
    setLoading(true);
    try {
      const response = await handleApiCall("get", endpoints.userBannerList);
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true
      ) {
        const responseData = response?.data?.data;
        const normalized = normalizeBannerData(responseData);
        setBanner(normalized?.[0] || null);
      } else {
        setBanner(null);
        console.error("Failed to fetch banner list:", response?.message);
      }
    } catch (error) {
      console.error("Error fetching banner list:", error);
      setBanner(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBanner();
  }, [fetchBanner]);

  useEffect(() => {
    if (!sectionRef.current || !banner?.wing_status) return;
    const sectionTop = sectionRef.current.offsetTop;
    setStartPoint(sectionTop + 0);
    setStartPoint(sectionTop)

    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (!wingRef.current) return;

      if (scrollY < startPoint) {
        wingRef.current.style.transform = `translateX(0px)`;
        return;
      }

      const sectionHeight = sectionRef.current.clientHeight;
      const scrollInside = scrollY - startPoint;
      const maxMove = sectionHeight - 200;
      const movement = Math.min(scrollInside, maxMove);

      wingRef.current.style.transform = `translateX(${movement}px)`;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [startPoint, banner?.wing_status]);
  
  const bannerTitle =
    getLocalizedFieldValue(banner, language, "title") || "";

  const bannerMidHeading =
  language === "AR"
    ? banner?.mid_heading_ar
    : banner?.mid_heading_en || "";

  const bannerLastHeading =
  language === "AR"
    ? banner?.last_heading_ar
    : banner?.last_heading_en || "";

  //console.log("banner saurabh", banner?.mobile_image);
  

  return (
    <>
      <section ref={sectionRef} className="bg-white bg-cover bg-center pt-28 relative overflow-hidden">
        {banner?.mobile_image ? (
          <img
            src={banner.mobile_image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover md:hidden pointer-events-none"
          />
        ) : null}
        {banner?.desktop_image ? (
          <img
            src={banner.desktop_image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover hidden md:block pointer-events-none"
          />
        ) : null}
        <div className='relative z-10 max-w-8xl mx-auto px-6 md:px-8 lg:px-2.5 2xl:px-0 flex flex-col justify-center h-full text-saudiaGreen'>
          <div className={`text-center ${language === "AR" ? "sm:mr-12 lg:mr-28 sm:text-right" : "sm:ml-12 lg:ml-28 sm:text-left"}`}>
            <h1 className={`sm:text-[4.5rem] md:text-[4.8rem] lg:text-[7.3rem] 2xl:text-[8.4rem] font-SaudiaBold mb-4 ${language === "AR" ? "text-[50px] leading-tight md:leading-none relative md:top-2.5" : "text-[64px] leading-none"}`}>
              {loading && !banner ? "..." : bannerTitle}
            </h1>
            <div className='sm:flex items-start 2xl:mr-1 gap-x-4 md:gap-x-8'>
              <div className="sm:min-w-[350px] lg:min-w-[575px]">
                <h2 className={`text-[20px] sm:text-[1.7rem] lg:text-[2.9rem] 2xl:text-[3.428rem] leading-tight font-SaudiaLight ${language === "AR" ? "relative md:top-3" : ""}`}>
                  {bannerMidHeading}
                </h2>
                <h3 className={`text-[20px] sm:text-[1.7rem] lg:text-[2.9rem] 2xl:text-[3.428rem] leading-tight mt-3 ${language === "AR" ? "font-SaudiaLight relative md:top-2" : "font-SaudiaExtraBoldItalic"}`}>
                  {bannerLastHeading}
                </h3>
              </div>
              <div className='flex items-end justify-end 2xl:mr-1 mt-6 sm:mt-0'>
                <img
                  ref={wingRef}
                  src={Wing}
                  alt="wing"
                  className={`transition-transform duration-200 ease-out sm 
                    ${banner?.wing_status ? "visible" : "invisible"}`}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
